import { FC, PropsWithChildren } from 'react'
import {
    Box,
    Container,
    SxProps,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material'
import { BackButton } from 'src/components/MUIBased/buttons'

type NavBarHeadingProps = {
    sx?: SxProps
    showBackButton?: boolean
    href?: string
    titleAlign?: 'center' | 'left'
}

export const NavBarHeading: FC<PropsWithChildren<NavBarHeadingProps>> = ({
    showBackButton = true,
    sx,
    href,
    children,
    titleAlign = 'center'
}) => {
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down('sm'))
    return (
        <Container sx={{ height: '68px', mt: 1 }}>
            <Box
                sx={{
                    position: 'relative',
                    ...sx
                }}
            >
                {!mobile && showBackButton && (
                    <BackButton
                        variant="default"
                        href={href}
                        sx={{
                            position: 'absolute',
                            left: 0,
                            top: 'calc(50% - 22px)'
                        }}
                    />
                )}

                <Typography
                    variant="h2"
                    sx={{
                        width: '100%',
                        textAlign: titleAlign,
                        height: '68px',
                        lineHeight: '68px',
                        mb: 0
                    }}
                >
                    {children}
                </Typography>
            </Box>
        </Container>
    )
}

export default NavBarHeading
